export const addDashboard = 'wt-add-dashboard';
export const addWorkspace = 'wt-add-workspace';
export const aliasUpdated = 'wt-alias-updated';
export const allRulesUpdated = 'wt-all-rules-updated';
export const applicationBackuped = 'wt-application-backuped';
export const applicationConnected = 'wt-application-connected';
export const applicationDisconnected = 'wt-application-disconnected';
export const applicationLogout = 'wt-application-logout';
export const applicationSelected = 'wt-application-selected';
export const applicationCreated = 'wt-application-created';
export const applicationSaved = 'wt-application-saved';
export const backButtonClick = 'wt-back-button-click';
export const compare = 'wt-compare';
export const connectionPointRemove = 'wt-connection-point-remove';
export const connectionPointSaved = 'wt-connection-point-saved';
export const connectionPointSelected='wt-connection-point-selected';
export const consolePrint = 'wt-console-print';
export const dataRefreshed = 'wt-data-refreshed';
export const formDirtyChanged = 'wt-form-dirty-changed';
export const groupAdded = 'wt-group-added';
export const groupRulesAddState = 'wt-group-rules-add-state';
export const groupRulesRemoveState = 'wt-group-rules-remove-state';
export const groupSaved = 'wt-group-saved';
export const groupSelected = 'wt-group-selected';
export const groupCanSelect = 'wt-group-can-select';
export const groupTreeToggled = 'wt-group-tree-toggled';
export const groupTreeChanged = 'wt-group-tree-changed';
export const groupScriptModeChanged = 'wt-group-script-mode-changed';
export const groupScriptUpdated = 'wt-group-script-updated';
export const identifierQuerySaved = 'wt-identifier-query-saved';
export const identifierSelected = 'wt-identifier-selected';
export const identifierSaved = 'wt-identifier-saved';
export const identifierSavedForce = 'wt-identifier-saved-force';
export const identifierDeleted = 'wt-identifier-deleted';
export const isEditMode = 'wt-is-edit-mode';
export const isMinimized = 'wt-is-minimized';
export const isPropertiesMode = 'wt-is-properties-mode';
export const itemSelected = 'wt-item-selected';
export const itemSelectionAllowed = 'wt-item-selection-allowed';
export const jobDefinitionSaved = 'wt-job-definition-allowed';
export const jobStarted = 'wt-job-started';
export const jobStarting = 'wt-job-starting';
export const jobStartFailed = 'wt-job-start-failed';
export const languageChanged = '$translateChangeSuccess';
export const logbookEntryAdded = 'wt-logbook-entry-added';
export const logbookEntryRemoved = 'wt-logbook-entry-removed';
export const logbookModalRefresh = 'wt-logbook-modal-refresh';
export const logRefreshed = 'wt-log-refreshed';
export const logout = 'wt-logout';
export const mailingEventJobUpdated = 'wt-mailing-event-job-updated';
export const mailingJobUpdated = 'wt-mailing-job-updated';
export const mailingJobDeleted = 'wt-mailing-job-deleted';
export const navigationHistoryUpdated = 'wt-navigation-history-updated';
export const notificationReceived = 'wt-notification-received';
export const oneRulesUpdated = 'wt-one-rules-updated';
export const rangeSelected = 'wt-range-selected';
export const referenceStateUpdated = 'wt-reference-state-updated';
export const referenceStateRemoved = 'wt-reference-state-removed';
export const referenceStateBrushed = 'wt-reference-state-brushed';
export const refreshClick = 'wt-refresh-click';
export const refreshLogClick = 'wt-refresh-log-click';
export const sendNotification = 'wt-send-notification';
export const seriesAdded = 'wt-series-added';
export const signalRConnectionStateChange = 'wt-signalr-connection-state-change';
export const shellContentEnter = 'wt-shell-content-enter';
export const showAverage = 'wt-show-average';
export const showStdDev = 'wt-show-stddev';
export const showGradient = 'wt-show-gradient';
export const strategySaved = 'wt-strategy-saved';
export const tagSelected = 'wt-tag-selected';
export const tasksChanged = 'tasksChanged';
export const toggleEditMode = 'wt-toggle-edit-mode';
export const toggleMaximizeWidget = 'wt-toggle-maximize-widget';
export const toggleMinimizeMenu = 'wt-toggle-minimize-menu';
export const togglePropertiesMode = 'wt-toggle-properties-mode';
export const treePinned = 'wt-tree-pinned';
export const treeUpdated = 'wt-tree-updated';
export const tagDefinitionGuidChanged = 'wt-tagDefinition-guid-changed';
export const tagSaved = 'wt-tag-saved';
export const tagsImported = 'wt-tag-imported';    
export const templateCreated = 'wt-template-created';
export const templateUpdated = 'wt-template-updated';
export const templateForceRefresh = 'wt-template-force-refresh';
export const treeViewNavigationStart = 'wt-tree-view-navigation-start';
export const treeViewNavigationEnd = 'wt-tree-view-navigation-end';
export const updateDashboard = 'wt-update-dashboard';
export const dashboardUpdated = 'wt-dashboard-updated';
export const widgetChanged = 'wt-widget-changed';
export const widgetDragged = 'wt-widget-dragged';
export const widgetResized = 'wt-widget-resized';
export const widgetSaved = 'wt-save-widget';
export const widgetDataInitialized = 'wt-widget-data-initialized';
export const wtDroppableDrop = 'wt-droppable-drop';
export const wtLoaded = 'wt-loaded';
export const wtTrendSelection = 'wt-trend-selection';
// log state
export const logsChangedFromIn = 'wt-logs-changed-from-in';
export const logsChangedFromOut = 'wt-logs-changed-from-out';
export const filteredLogsChangedFromIn = 'wt-filtered-logs-changed-from-in';
export const filteredLogsChangedFromOut = 'wt-filtered-logs-changed-from-out';
export const selectedLogChangedFromIn = 'wt-selected-log-changed-from-in';
export const selectedLogChangedFromOut = 'wt-selected-log-changed-from-out';
export const filterChangedFromIn = 'wt-filter-changed-from-in';
export const filterChangedFromOut = 'wt-filter-changed-from-out';
export const beginDateChangedFromIn = 'wt-beginDate-changed-from-in';
export const beginDateChangedFromOut = 'wt-beginDate-changed-from-out';
export const endDateChangedFromIn = 'wt-beginDate-changed-from-in';
export const endDateChangedFromOut = 'wt-beginDate-changed-from-out';
export const datesChangedFromIn = 'wt-dates-changed-from-in';
export const datesChangedFromOut = 'wt-dates-changed-from-out';
// other messages
export const stateChangeStart = '$stateChangeStart';
export const stateChangeSuccess = '$stateChangeSuccess';
export const historianStorageConfigurationSaving = 'historianStorageConfigurationSaving';
export const historianStorageConfigurationSaved = 'historianStorageConfigurationSaved';
export const updateSchedulingIcons = 'update-scheduling-icons';